module.exports = __webpack_public_path__ + "img/qilin-stage7-hungry.5ba23061.png";